import axios from 'axios';
import store from '../store';

/**
 * Simple API class service for making Axios calls
 * and returning a promise for each call
 */
class Api {

  constructor() {
    this.base = '/api';
  }

  /**
   * Get
   * @param {string} endpoint
   * @param {*} params
   * @param headers
   */
  get(endpoint, params = {}, headers = {}) {
    return new Promise((resolve, reject) => {
      return axios({
        url: this.base + endpoint,
        headers: {
          ...this.buildHeaders(),
          ...headers,
        },
        params,
        method: 'GET',
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      })
    });
  }

  /**
     * Post
     * @param {string} endpoint
     * @param {*} data
     */
  post(endpoint, data = {}) {
    return new Promise((resolve, reject) => {
      return axios({
        url: this.base + endpoint,
        headers: this.buildHeaders(),
        data: data,
        method: 'POST',
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      })
    });
  }

  rawPost(endpoint, data = {}) {
    return axios({
      url: this.base + endpoint,
      headers: this.buildHeaders(),
      data: data,
      method: 'POST',
    });
  }

  /**
     * PUT
     * @param {string} endpoint
     * @param {*} data
     */
  put(endpoint, data = {}) {
    return new Promise((resolve, reject) => {
      return axios({
        url: this.base + endpoint,
        headers: this.buildHeaders(),
        data: data,
        method: 'PUT',
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      })
    });
  }

  /**
     * Delete
     * @param {string} endpoint
     * @param {*} params
     */
  delete(endpoint, params = {}) {
    return new Promise((resolve, reject) => {
      return axios({
        url: this.base + endpoint,
        headers: this.buildHeaders(),
        params,
        method: 'DELETE',
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      })
    });
  }

  /**
     * Make query string
     * @param {*} params
     */
  makeQueryString(params = {}) {
    return Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');
  }

  buildHeaders() {
    const token = store.state.user.token;

    if (token) {
      return {
        'Authorization': `Bearer ${token}`,
      };
    }

    return {};
  }
}

export default new Api;
